@use "variables" as *;

.icon {
  color: $icon-primary-color;
}
